import script from "./UiKitView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiKitView.vue?vue&type=script&setup=true&lang=ts"

import "./UiKitView.vue?vue&type=style&index=0&id=3c1e31eb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1e31eb"]])

export default __exports__